import React, { useEffect, useState, useCallback } from "react";
import MetaTags from "react-meta-tags";
import PropTypes from "prop-types";
import { Col, Container, Row, Label, Card, Button } from "reactstrap";
import SweetAlert from "react-bootstrap-sweetalert";
// Redux
import { useDispatch, useSelector } from "react-redux";
import { withRouter, useHistory } from "react-router-dom";

//Action
import { casosLista } from "../../store/casos/actions";

import { grupotecnicoList } from "../../store/grupoTecnico/actions";
import { contactsList } from "../../store/contacts/actions";
import { leadsLista } from "../../store/leads/actions";

import PreContactoForm from "./components/componentCasosAdd/PreContactoForm";
import ContactoForm from "./components/componentCasosAdd/ContactoForm";
import Formulario from "./components/componentCasosAdd/Formulario";

import { getContactsFilterAsync, postCasosCreate } from "../../helpers/backend.js";

const CasosAdd = () => {
  const dispatch = useDispatch();
  const [checked, setchecked] = useState(true);
  const history = useHistory();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [casoCreado, setCasoCreado] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    dispatch(casosLista());

    dispatch(grupotecnicoList());
    dispatch(contactsList());
    dispatch(leadsLista());
  }, [dispatch]);



  const changeLista = (e) => {
    setchecked(e.target.checked);
  };

  const grupotTecnico =
    useSelector((state) => state.GrupoTecnico.grupotecnico.results) || [];
    const contact = useSelector((state) => state.Contacts.contacts.results?.data) || [];
    console.log(contact);
    

  const leads = useSelector((state) => state.Leads.leads) || [];

  const [selectedTipoVisita, setselectedTipoVisita] = useState(null);

  const [selectedTipoServicio, setSelectedTipoServicio] = useState(null);

  const [selectedGrupoTecnico, setSelectedGrupoTecnico] = useState(null);

  const tipo_servicio = selectedTipoServicio;

  const tipo_visita = selectedTipoVisita;

  const [selectedContacto, setSelelectedContacto] = useState(null);

  const contacto = selectedContacto;

  const [selectedPreContacto, setSelelectedPreContacto] = useState(null);

  const pre_contacto = selectedPreContacto;
  const [sdnuevo, setSdnuevo] = useState(null);

  const [formData, setFormData] = useState({
    observaciones: "",
    detallesServicio: "",
    tecnico_asignado: [],
    datosServicio: "",
  });

  const { observaciones, detallesServicio, tecnico_asignado, datosServicio } =
    formData;

  const onChange = (e) => {
    const uppercaseValue = e.target.value.toUpperCase();
    setFormData({ ...formData, [e.target.name]: uppercaseValue });
  };

  function handleSelectContacto(selectedContacto) {
    setSelelectedContacto(selectedContacto.value);
  }

  function handleSelectPreContacto(selectedPreContacto) {
    setSelelectedPreContacto(selectedPreContacto.value);
  }

  function handleSelectTipoServcio(selectedTipoServicio) {
    setSelectedTipoServicio(selectedTipoServicio.value);
  }

  function handleSelectGrupoTecnico(selectedGrupoTecnico) {
    setSelectedGrupoTecnico(selectedGrupoTecnico.value);
  }

  const grupo_tecnico = selectedGrupoTecnico;

  const getContactsData = useCallback(async () => {
    try {
      const response = await getContactsFilterAsync(
        `grupo-tecnico/${selectedGrupoTecnico}/`
      );
      const data = response.data;

      setSdnuevo(data);
    } catch (error) {
      console.error("Error fetching contacts data:", error);
    }
  }, [selectedGrupoTecnico]);

  useEffect(() => {
    getContactsData();
  }, [selectedGrupoTecnico, getContactsData]);
  // Esto se ejecutará después de la actualización de sdnuevo

  function handleSelectTipoVisita(selectedTipoVisita) {
    setselectedTipoVisita(selectedTipoVisita.value);
  }

  const [fechacalendario, setFechaAsignada] = useState(null);

  const [horaEntrada, setHoraEntrada] = useState(null);

  const [horaSalida, setHoraSalida] = useState(null);

  let lapso_hora_entrada = "";
  let lapso_hora_salida = "";

  const onChangeFecha = (e) => {
    setFechaAsignada(e.target.value);
  };

  const fecha_asignacion = fechacalendario;

  const onChangeHoraEntrada = (e) => {
    if (e && e.target && e.target.value) {
      setHoraEntrada(e.target.value);
    }
  };

  let horaEntraRec = horaEntrada?.toString().slice(0, 5);
  lapso_hora_entrada = horaEntraRec;

  const onChangeHoraSalida = (e) => {
    if (e && e.target && e.target.value) {
      setHoraSalida(e.target.value);
    }
  };

  let horaSalidaRec = horaSalida?.toString().slice(0, 5);
  lapso_hora_salida = horaSalidaRec;

  const [image, setFormDataImage] = useState([]);

  const handleImageChange = (evImages) => {
    Array.from(evImages).forEach((image) => {
      var reader = new FileReader();
      reader.readAsDataURL(image);
      reader.onload = function () {
        var img = [];
        var base64 = reader.result;
        img = base64.split(",");
        setFormDataImage((prevImages) => [...prevImages, { image: img[1] }]);
      };
    });
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    
    // Validación básica
    if (!checked && !pre_contacto) {
      alert("Por favor selecciona un pre-contacto");
      return;
    }
    
    if (checked && !contacto) {
      alert("Por favor selecciona un contacto");
      return;
    }
    
    if (!tipo_visita) {
      alert("Por favor selecciona el tipo de visita");
      return;
    }
    
    if (!grupo_tecnico) {
      alert("Por favor selecciona el grupo técnico");
      return;
    }
    
    console.log("submit");
    setIsSubmitting(true);
    setError(null);
    
    try {
      const response = await postCasosCreate({
        pre_contacto,
        contacto,
        tipo_visita,
        fecha_asignacion,
        lapso_hora_entrada: lapso_hora_entrada || "",
        lapso_hora_salida: lapso_hora_salida || "",
        tecnico_asignado,
        tipo_servicio,
        observaciones,
        detallesServicio,
        grupo_tecnico,
        images: image,
        datosServicio,
        modelo_desplazamiento: false,
      });
      
      if (response.status === 201) {
        console.log("Caso creado exitosamente:", response.data);
        setCasoCreado(response.data);
      } else {
        setError("Error al crear el caso. Por favor intenta nuevamente.");
      }
    } catch (error) {
      console.error("Error al crear caso:", error);
      setError(error.response?.data?.message || "Error al crear el caso. Por favor intenta nuevamente.");
    } finally {
      setIsSubmitting(false);
    }
  };

  //Options
  const TipoVisita = [
    {
      options: [
        { label: "VISITA CONTRATO", value: "VISITA CONTRATO" },
        { label: "VISITA ADICIONAL", value: "VISITA ADICIONAL" },
        { label: "VENTA", value: "VENTA" },
        { label: "GARANTIA", value: "GARANTIA" },
        { label: "REVISION O REPARACION", value: "REVISION O REPARACION" },
        { label: "ENTREGA", value: "ENTREGA" },
        {
          label: "LEVANTAMIENTO DE INFORMACION",
          value: "LEVANTAMIENTO DE INFORMACION",
        },
        {
          label: "MANTENIMIENTO PREVENTIVO",
          value: "MANTENIMIENTO PREVENTIVO",
        },
        {
          label: "MANTENIMIENTO CORRECTIVO",
          value: "MANTENIMIENTO CORRECTIVO",
        },
        { label: "MENSAJERIA", value: "MENSAJERIA" },
        { label: "COMPRAS", value: "COMPRAS" },
        { label: "PARTNER", value: "PARTNER" },
        { label: "COTIZAR EN EL SITIO", value: "COTIZAR EN EL SITIO" },
        { label: "INSTALACION", value: "INSTALACION" },
      ],
    },
  ];

  const TipoServicio = [
    {
      options: [
        { label: "PRESENCIAL", value: "PRESENCIAL" },
        { label: "REMOTO", value: "REMOTO" },
        { label: "MIXTO", value: "MIXTO" },
      ],
    },
  ];

  const redirect = () => {
    history.push("/casos");
  };

  return (
    <React.Fragment>
      {casoCreado?.id ? (
        <SweetAlert
          title="Hecho!"
          success
          timeout={1000}
          showConfirm={false}
          onConfirm={() => {
            redirect();
          }}
        >
          Se ha agregado el caso {casoCreado.id}
        </SweetAlert>
      ) : null}
      {error && (
        <SweetAlert
          title="Error!"
          error
          onConfirm={() => setError(null)}
        >
          {error}
        </SweetAlert>
      )}
      <div className="page-content">
        <MetaTags>
          <title> Registra Caso</title>
        </MetaTags>
        <Container fluid>
          <Card className="col-lg-8 mx-auto  mt-3">
            <Row className="needs-validation p-2">
              <div
                className="form-check form-switch mb-3 "
                style={{ marginLeft: "10px" }}
              >
                <input
                  className="form-check-input mt-2 "
                  type="checkbox"
                  id="flexSwitchCheckChecked"
                  onChange={changeLista}
                  checked={checked}
                />
                <Label
                  className="form-check-label mt-2 "
                  for="flexSwitchCheckChecked"
                >
                  <strong>Es Contacto</strong>{" "}
                </Label>
              </div>

              {!checked ? (
                <>
                  <PreContactoForm
                    grupotTecnico={grupotTecnico}
                    leads={leads}
                    TipoVisita={TipoVisita}
                    handleSelectTipoVisita={handleSelectTipoVisita}
                    TipoServicio={TipoServicio}
                    contact={contact}
                    handleSelectPreContacto={handleSelectPreContacto}
                  ></PreContactoForm>

                  <Formulario
                    onChange={onChange}
                    TipoVisita={TipoVisita}
                    handleSelectTipoServcio={handleSelectTipoServcio}
                    TipoServicio={TipoServicio}
                    handleImageChange={handleImageChange}
                    grupotTecnico={grupotTecnico}
                    onChangeFecha={onChangeFecha}
                    onChangeHoraEntrada={onChangeHoraEntrada}
                    onChangeHoraSalida={onChangeHoraSalida}
                    handleSelectGrupoTecnico={handleSelectGrupoTecnico}
                    sd={sdnuevo}
                    setFormData={setFormData}
                    formData={formData}
                  ></Formulario>
                </>
              ) : (
                <>
                  <ContactoForm
                    handleSelectContacto={handleSelectContacto}
                    grupotTecnico={grupotTecnico}
                    leads={leads}
                    TipoVisita={TipoVisita}
                    handleSelectTipoVisita={handleSelectTipoVisita}
                    contact={contact}
                  ></ContactoForm>

                  <Formulario
                    onChange={onChange}
                    TipoVisita={TipoVisita}
                    TipoServicio={TipoServicio}
                    handleSelectTipoServcio={handleSelectTipoServcio}
                    handleImageChange={handleImageChange}
                    grupotTecnico={grupotTecnico}
                    onChangeFecha={onChangeFecha}
                    onChangeHoraEntrada={onChangeHoraEntrada}
                    onChangeHoraSalida={onChangeHoraSalida}
                    handleSelectGrupoTecnico={handleSelectGrupoTecnico}
                    sd={sdnuevo}
                    setFormData={setFormData}
                    formData={formData}
                  ></Formulario>
                </>
              )}

              <Row className="col-lg-12 justify-content-center">
                <Col md={1} className="mx-3">
                  <Button 
                    color="primary" 
                    onClick={(e) => onSubmit(e)}
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? "Enviando..." : "Enviar"}
                  </Button>
                </Col>
                <Col md={1} className="mx-3">
                  <Button
                    className="btn btn-secondary"
                    type="button"
                    onClick={redirect}
                  >
                    Volver
                  </Button>
                </Col>
              </Row>
            </Row>
          </Card>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withRouter(CasosAdd);
